import React from "react";
import DeleteIcon from "../ui/DeleteIcon";
import { addZero, dateToMonth } from "../../lib/utils";

function BookingPrintServices({ booking }) {
  return (
    <>
      {booking.selectedServices?.length > 0 &&
        booking.selectedServices.flatMap((service) =>
          Array.from({ length: service.count || 1 }, (_, index) => (
            <div
              key={`ss-${service.id || service.name}-${index}`}
              className="mt6"
            >
              <p className="dfa dfsp">
                <span className="dfa gap5">
                  <span
                    className="curp"
                    onClick={() =>
                      booking.addService({
                        ...service,
                        count: service.count - 1,
                      })
                    }
                  >
                    <DeleteIcon w={14} h={16} />
                  </span>{" "}
                  <span>{service.name}</span>
                </span>
                {service?.date && (
                  <span className="pb_dates">
                    {dateToMonth(service.date, true)}&nbsp;&nbsp;&nbsp;
                    {addZero(service.hour)}:{addZero(service.minute)} -{" "}
                    {addZero(service.h_end_p)}:{addZero(service.m_end_p)}
                  </span>
                )}
              </p>
            </div>
          )),
        )}
    </>
  );
}

export default BookingPrintServices;
